import { render } from "./SplitZigZag.vue?vue&type=template&id=97f0589c"
import script from "./SplitZigZag.vue?vue&type=script&lang=js"
export * from "./SplitZigZag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__